import React from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from './Modal';
import Button from './Button';
import { logout } from '../utils/auth';

const SessionExpiredModal = ({ isOpen }) => {
  const navigate = useNavigate();

  return (
    <Modal
      name="session-expired"
      isOpen={isOpen}
      onClose={logout}
      title="Session Expired"
      description="Please log in again to continue."
      closeOnBackdropClick={false}
    >
      <div className="space-y-4 text-center">
        <p className="text-gray-600 text-sm">
          Your session has expired. Please log in again to continue managing your account.
        </p>

        <Button
          variant="primary"
          fullWidth
          onClick={logout}
        >
          Log in again
        </Button>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal; 